import React, {Component} from "react";
import {connect} from "react-redux";
import {next, back, setTotal, advance, revert} from "../../actions";
import * as components from "../../pages";

const isProgressPage = (page) => (page.type === 'ProgressPage');
const enhance = connect(
  ({switcher, progress}, {storyboard}) => {
    const currentStep = switcher.currentStep;
    return { currentStep, storyboard, progress }
  },
  (dispatch) =>({
    next: () => dispatch(next()),
    advance: () => dispatch(advance()),
    back: () => dispatch(back()),
    revert: () => dispatch(revert()),
    initProgress: (total) => dispatch(setTotal(total))
  })
);

class Switcher extends Component {
  componentDidMount(){
    const progressOnly = this.props.storyboard.filter(isProgressPage);
    this.props.initProgress(progressOnly.length);
  }

  render() {
    const { currentStep, storyboard, initProgress, ...rest } = this.props;
    const screen = storyboard[currentStep];

    const ScreenComponent = components[screen.type] || null;
    const {backgroundImage, ...screenProps} = screen.props || {};
    const backgroundImageSrc = components[backgroundImage];

    const props = {...screenProps, ...rest};

    return (
      <div>
        {backgroundImageSrc && <img src={backgroundImageSrc} alt="" className="background"/>}
        <ScreenComponent {...props} />
      </div>
    )
  }
}

export default enhance(Switcher);


// WEBPACK FOOTER //
// ./src/components/switcher/index.js